"use client";
import V2 from "./_v2/PariV2";
export default function Page() { return <V2 />; }
